import { useSelector } from 'react-redux';
import { FUEL_TYPE_MAP } from '../docs/constants';
import { selectRefiDocsFormData} from '../../redux-state/selectors';

function VehicleInfoRefiDoc() {
  const refiDocsFormData = useSelector(selectRefiDocsFormData)

  const getFullFuelType = (input) => {
    return FUEL_TYPE_MAP[input] || input;
  }

  const fuelType = getFullFuelType(refiDocsFormData?.fuelType)

  return (
    <>
      <div className='border-t-2 border-t-gray-100 mb-3'>
        <div className='text-gray-700 mt-6 font-bold'>
          Vehicle Information <span className='text-xs text-gray-600 font-normal ml-1'>{refiDocsFormData?.vinCode}</span>
        </div>
      </div>

      <div className='flex flex-col lg:flex-row w-full gap-6 lg:gap-24 mb-6'>
        <div className='flex flex-col w-[100%] text-gray-700 gap-2'>
          {refiDocsFormData?.vehicleType &&
            <div className='flex flex-row justify-between'>
              <div>
                Vehicle Type:
              </div>
              <div className='font-medium'>
                {refiDocsFormData?.vehicleType}
              </div>
            </div>
          }

          {refiDocsFormData?.modelYear &&
            <div className='flex flex-row justify-between'>
              <div>
                Model Year:
              </div>
              <div className='font-medium'>
                {refiDocsFormData?.modelYear}
              </div>
            </div>
          }

          {refiDocsFormData?.model &&
            <div className='flex flex-row justify-between'>
              <div>
                Model:
              </div>
              <div className='font-medium'>
                {refiDocsFormData?.model}
              </div>
            </div>
          }

          {refiDocsFormData?.numberOfAxles &&
            <div className='flex flex-row justify-between'>
              <div>
                Number of Axles:
              </div>
              <div className='font-medium'>
                {refiDocsFormData?.numberOfAxles}
              </div>
            </div>
          }

          {refiDocsFormData?.fuelType &&
            <div className='flex flex-row justify-between'>
              <div>
                Fuel Type:
              </div>
              <div className='font-medium'>
                {fuelType}
              </div>
            </div>
          }

          <div className='flex flex-row justify-between'>
            <div>
              Registration Months:
            </div>
            <div className='font-medium'>
              {refiDocsFormData?.registrationMonths}
            </div>
          </div>

          {refiDocsFormData?.odometer &&
            <div className='flex flex-row justify-between'>
              <div>
               Odometer (miles):
              </div>
              <div className='font-medium'>
                {refiDocsFormData?.odometer}
              </div>
            </div>
          }

          {refiDocsFormData?.color &&
            <div className='flex flex-row justify-between'>
              <div>
                Color:
              </div>
              <div className='font-medium'>
                {refiDocsFormData?.color}
              </div>
            </div>
          }

          {refiDocsFormData?.gvw &&
            <div className='flex flex-row justify-between'>
              <div>
                GVW (lbs):
              </div>
              <div className='font-medium'>
                {refiDocsFormData?.gvw}
              </div>
            </div>
          }

          {refiDocsFormData?.horsepower &&
            <div className='flex flex-row justify-between'>
              <div>
                Horsepower:
              </div>
              <div className='font-medium'>
                {refiDocsFormData?.horsepower}
              </div>
            </div>
          }
        </div>

        <div className='flex flex-col w-[100%] text-gray-700 gap-2'>
          {refiDocsFormData?.condition &&
            <div className='flex flex-row justify-between'>
              <div>
                Condition:
              </div>
              <div className='font-medium'>
                {refiDocsFormData?.condition}
              </div>
            </div>
          }

          <div className='flex flex-row justify-between'>
            <div>
              Make:
            </div>
            <div className='font-medium'>
              {refiDocsFormData?.make}
            </div>
          </div>

          {refiDocsFormData?.bodyStyle &&
            <div className='flex flex-row justify-between'>
              <div>
                Body Style:
              </div>
              <div className='font-medium'>
                {refiDocsFormData?.bodyStyle}
              </div>
            </div>
          }

          {refiDocsFormData?.numberOfTires &&
            <div className='flex flex-row justify-between'>
              <div>
                Number of Tires:
              </div>
              <div className='font-medium'>
                {refiDocsFormData?.numberOfTires}
              </div>
            </div>
          }

          {refiDocsFormData?.cylinders &&
            <div className='flex flex-row justify-between'>
              <div>
                Cylinders:
              </div>
              <div className='font-medium'>
                {refiDocsFormData?.cylinders}
              </div>
            </div>
          }

          {refiDocsFormData?.rimSize &&
            <div className='flex flex-row justify-between'>
              <div>
                Rim Size(Inches):
              </div>
              <div className='font-medium'>
                {refiDocsFormData?.rimSize}
              </div>
            </div>
          }

          {refiDocsFormData?.vehicleWeight &&
            <div className='flex flex-row justify-between'>
              <div>
                Weight (Ibs):
              </div>
              <div className='font-medium'>
              {refiDocsFormData?.vehicleWeight}
              </div>
            </div>
          }

          {refiDocsFormData?.mpg &&
          <div className='flex flex-row justify-between'>
            <div>
              MPG (Average):
            </div>
            <div className='font-medium'>
              {refiDocsFormData?.mpg}
            </div>
          </div>
          }

          {refiDocsFormData?.msrp &&
            <div className='flex flex-row justify-between'>
              <div>
                MSRP:
              </div>
              <div className='font-medium'>
                {refiDocsFormData?.msrp}
              </div>
            </div>
          }
        </div>
      </div>
    </>
  )
}

export default VehicleInfoRefiDoc
